import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import '../fabrisorb/fabrisorb-style.css';
import ScrollToTopButton from '../ScrollButton';
import SliderDiffuso from './SliderDiffuso';
import SliderPrdDiffuso from './SliderPrdDiffuso';
import SliderQrdDiffuso from './SliderQrdDiffuso';
function Deffuso() {
    return (

        <>
            <Helmet>
                <title>Innovative 2D Acoustic Diffusers for Perfect Reflection Control</title>
                <meta name="description" content="Control sound reflections with DIFFUSO, the perfect solution for balanced acoustics in professional and personal spaces." />
                <meta name="robots" content="index, follow" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="in" />
                <meta name="geo.region" content="india" />
                <meta property="og:title" content="Foamwood Panels" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/tiles.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="alternate" href="https://www.acousticalsurfaces.ae/fabrisorb" hreflang="en-ae" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/fabrisorb" hreflang="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/fabrisorb" />
            </Helmet>
            <Header />
            <section className="content" id="fabrisorb">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container thanks">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                                <div className="col-sm-12 heading-fsorb">
                                    <h1>DIFFUSO</h1>
                                    <p>DIFFUSO is a 2-Dimensional PRD Diffuser carefully designed utilizing modulated prime root number theory. The calculation shows us that the reflected energies will be equal in all the diffraction directions. They are used to control reflections in the listening environment, particularly from rear walls and first-reflection points.</p>
                                    <SliderDiffuso />

                                    <div className="flex-container mt-4">
                                        <Link to="https://www.acousticalsurfaces.in/catalogue/diffuso/diffuso-wooden-diffuser-catalogue.pdf" className="btn btn-danger justify-content-center" target='_blank'>Downloads</Link>
                                    </div>
                                </div>
                                <div className="col-sm-12 features">
                                    <h1>Features</h1>
                                    <div className="line"></div>
                                    <div className="row pad">
                                        <div className="col-md-8 col-sm-12">
                                            <ul>
                                                <li>Made from solid wood</li>
                                                <li>Long lasting and impact resistant</li>
                                                <li>Highly aesthetic on exposed installation</li>
                                                <li>Reduce Flutter Echoes and Sound Bouncing of the walls</li>
                                                <li>Works best on Mid-High frequencies</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-4 col-sm-12 tiles bgimage">
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 features">
                                    <h1>Applications</h1>
                                    <div className="line"></div>
                                    <div className="row pad">
                                        <div className="col-md-6 col-sm-12 d-none d-md-block">
                                            <ul>
                                                <li>Studios</li>
                                                <li>Mixing Rooms</li>
                                                <li>Hi-Fi Rooms</li>
                                                <li>Home Theaters</li>
                                                <li>Auditoriums</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 printing">
                                    <div className="col-sm-12 more">
                                        <h1>More Products</h1>
                                        <div className="line"></div>
                                    </div>
                                    <div className="accordion-started accordion-bral panels row">
                                        <div className="col-sm-12 col-md-12 col-lg-12 ">
                                            <label className="ac-label" htmlFor="ac-1">
                                                <b>DiFFUSO</b><br />PRD Wooden Diffuser<i></i>
                                            </label>
                                            <div className="article ac-content">
                                                <SliderPrdDiffuso />
                                                <p>DIFFUSO is a 2-Dimensional PRD Diffuser carefully designed utilizing modulated prime root number theory. The calculation shows us that the reflected energies will be equal in all the diffraction directions. They are used to control reflections in the listening environment, particularly from rear walls and first-reflection points.</p>
                                                <h2>Product Details</h2>
                                                <br />
                                                <div className="col-sm-12">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item">
                                                            <a className="nav-link active show" data-toggle="tab" href="#home">SPECIFICATION</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className="nav-link" data-toggle="tab" href="#menu3">DATASHEET</a>
                                                        </li>
                                                    </ul>
                                                    <div className="tab-content">
                                                        <div id="home" className="tab-pane active show"><br />
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <th scope="row">Range</th>
                                                                        <td>1147Hz to 3440Hz</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Dimensions</th>
                                                                        <td>600mm x 600mm x 150mm</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Material</th>
                                                                        <td>Pine wood</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Fire rating</th>
                                                                        <td>Treated with FR coatings to meet EN 13501 / BS 476 standards</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Colour</th>
                                                                        <td>Any RAL colour choice</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Base</th>
                                                                        <td>FR Rated Plywood</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div id="menu3" className="tab-pane fade"><br />
                                                            <br />
                                                            <h3>PRD Wooden Diffuser : Datasheet</h3>
                                                            <br />
                                                            <a target="_blank" rel="noopener noreferrer" href="https://www.acousticalsurfaces.in/catalogue/diffuso/diffuso-prd-catalogue.pdf" className="brochure">Download</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="line"></div>
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <label className="ac-label" htmlFor="ac-2">
                                                <b>DiFFUSO</b><br />QRD Wooden Diffuser<i></i>
                                            </label>
                                            <div className="article ac-content">
                                                <SliderQrdDiffuso />
                                                <p>If the room is overtreated with absorption, too many high frequencies could get absorbed, resulting in a dead, boomy and dry room. Diffusion can be used alongside absorption to treat reflective rooms but without removing too much sound energy; result is a more diffusive and lively room over a drier or dead room. Our QRD Diffusers allows mid and high frequencies to remain in space longer compared to absorption.</p>
                                                <h2>Product Details</h2>
                                                <br />
                                                <div className="col-sm-12">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item">
                                                            <a className="nav-link active" data-toggle="tab" href="#cp-home">SPECIFICATION</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className="nav-link" data-toggle="tab" href="#cp-menu3">DATASHEET</a>
                                                        </li>
                                                    </ul>
                                                    <div className="tab-content">
                                                        <div id="cp-home" className="container tab-pane active"><br />
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <th scope="row">Dimensions</th>
                                                                        <td> 600mm / 1200mm (Length) x 600 (Breadth)mm x 200 (Depth)mm</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Material</th>
                                                                        <td>Fire rated MDF</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Fire rating</th>
                                                                        <td>FR coatings to meet ASTM E84/EN 13501 standards</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th scope="row">Colour</th>
                                                                        <td>RAL colour / Wood veneer / Laminate finishes available</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div id="cp-menu3" className="container tab-pane fade"><br />
                                                            <br />
                                                            <h3>QRD Wooden Diffuser : Datasheet</h3>
                                                            <br />
                                                            <a target="_blank" rel="noopener noreferrer" href="https://www.acousticalsurfaces.in/datasheet/diffuso/diffuso-qrd-wooden-diffuser.pdf" className="brochure">Download</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    );
}
export default Deffuso; 